import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { SystemLogsFilterOption } from '../models/system-log-filter-option';
import { LogRegisterListItem } from '../models/system-log-register-results.model';

const area = 'Log Register';
export const logRegisterAdapterActions = createRegisterActions<LogRegisterListItem>(area);

export const logRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: SystemLogsFilterOption[] }>()
);

export const loadSystemLogsSuccess = createAction(`[System ${area}] Register Load Success`);

export const loadAccountLogsSuccess = createAction(`[Account ${area}] Register Load Success`);

export const openDialog = createAction('[System Logs] Open Dialog', props<{ callLogs: any }>());

export const openLogDialog = createAction('[System Logs] Open Log Dialog', props<{ callLogs: any }>());

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);
